import { useCallback } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { getBillingPartyString } from '../../../../containers/AppPage/Sales/helper';
import { L } from '../../../../redux/List/reducer';
import {Type} from "../../../../redux/Transaction/helper";
import {useListManager} from "../../../../redux/List/helper";

const selectorFn = state => ({
    contacts: state.List.contacts,
    contactAddresses: state.List.contactAddresses,
    companyAddresses: state.List.companyAddresses,
    transactionInitState: state.Transaction.transactionInitState,
    transactionReadState: state.Transaction.transactionReadState,
    contactId: state.Transaction.contactId,
    readListsState: state.List.readListsState,
});

export function useAddresses({ form, specs, transactionType }) {
    const listManagerContact = useListManager([L.contact_addresses]);
    const listManagerCompany = useListManager([L.company_addresses]);

    // Redux
    const {
        contacts,
        contactAddresses,
        companyAddresses,
        contactId,
    } = useSelector(selectorFn, shallowEqual);

    const readAddresses = useCallback(contactId => {
        if (!contactId)
            return null;
        if (specs.contactAddresses)
            listManagerContact.readLists({ contact_addresses: { contact_id: contactId } });
        if (specs.companyAddresses)
            listManagerCompany.readLists();
        return null;
    }, [
        listManagerContact, listManagerCompany, specs.companyAddresses, specs.contactAddresses,
    ]);

    /**
     *
     * @param {int} selectedOption selected id of contactAddresses (required)
     * @param {String} locationType 'billing' or 'shipping' (required)
     */
    const onLocationChange = useCallback((selectedOption, locationType) => {
        if (contactId) {
            const contact = contacts.find(contact => contact.id === contactId);
            // Billing
            switch (locationType) {
                case 'billing': {
                    const addressInfo = contactAddresses.find(a => a.id === selectedOption);
                    return form.setFieldsValue({
                        billing_party: getBillingPartyString(contact, addressInfo.address),
                    });
                }
                case 'shipping': {
                    switch (transactionType) {
                        case Type.purchase_order:
                        case Type.purchase_goods_received_note:
                        case Type.purchase_bill:
                        case Type.purchase_credit_note: {
                            // The rest:
                            const addressInfo = companyAddresses.find(a => a.id === selectedOption);
                            return form.setFieldsValue({ shipping_party: addressInfo.address });
                        }
                        default: {
                            const addressInfo = contactAddresses.find(a => a.id === selectedOption);
                            return form.setFieldsValue({
                                shipping_party: getBillingPartyString(contact, addressInfo.address),
                            });
                        }
                    }
                }
                default:
                    throw new Error("locationType not specified.");
            }
        }
        // shipping details could be edited even without contactId
        else if (locationType === 'shipping') {
            // ONLY PO, GR:
            const addressInfo = companyAddresses.find(a => a.id === selectedOption);
            return form.setFieldsValue({ shipping_party: addressInfo.address });
        }
        return null;
    }, [companyAddresses, contactAddresses, contactId, contacts, form, transactionType]);

    return {
        readAddresses,
        onLocationChange,
    };
}
